import { findNippleAngle, findPectNippleLineMLO, getProjectionPoint } from './vectorOperations';

export function addDerivedFeaturesCC(resultCC, projection, flip, nippleAngleThresholds, field) {
  try {
    if (!nippleAngleThresholds || !projection) return;

    const { location_nipple, location_nipple_projection, PectoralisCC, PectoThickness } = resultCC;
    const { img_size_x, img_size_y } = projection;

    // PNL
    const x = Math.abs(location_nipple?.[0] - location_nipple_projection?.[0]) * img_size_x;
    const y = Math.abs(location_nipple?.[1] - location_nipple_projection?.[1]) * img_size_y;
    resultCC.PectoNippleLength = Math.sqrt(x * x + y * y);

    // Nipple angle and nipple centered
    if (field == 'PectoralisCC') return;

    const nippleAngle = findNippleAngle(location_nipple_projection, location_nipple, [
      img_size_x,
      img_size_y,
    ]);
    let nippleCentered;
    if (Math.abs(nippleAngle) < nippleAngleThresholds?.[0]) nippleCentered = 'correct';
    else if (Math.abs(nippleAngle) < nippleAngleThresholds?.[1]) nippleCentered = 'moderate';
    else nippleCentered = 'insufficient';

    resultCC.NippleCentered = nippleCentered;
    resultCC.NippleAngle = nippleAngle;
  } catch (err) {
    console.log(err);
  }
}

export function addDerivedFeaturesMLO(resultMLO, projection, flip, pnlFromEdge, pectLevelClasses) {
  try {
    if (pnlFromEdge === undefined || pnlFromEdge === null || !projection || !resultMLO) return;

    const { location_nipple, location_pecto_top, location_pecto_bottom } = resultMLO;
    const { img_size_x, img_size_y } = projection;

    const pnl = findPectNippleLineMLO(
      location_pecto_top,
      location_pecto_bottom,
      location_nipple,
      img_size_x,
      img_size_y,
      flip
    );

    const projPoint = getProjectionPoint(
      location_pecto_top,
      location_pecto_bottom,
      location_nipple,
      img_size_x,
      img_size_y,
      flip,
      pnlFromEdge
    );

    let pectoLevel;
    // TODO tolerance should be fetched from backend and fix this ugly code :D
    const tolerance = 0.065;
    if (pectLevelClasses?.length === 2) {
      if (location_nipple?.[1] <= location_pecto_bottom?.[1] + tolerance) pectoLevel = 'correct';
      else if (projPoint?.[1] / img_size_y <= location_pecto_bottom?.[1] + tolerance) pectoLevel = 'correct';
      else pectoLevel = 'insufficient';
    } else {
      if (location_nipple?.[1] <= location_pecto_bottom?.[1] + tolerance) pectoLevel = 'correct';
      else if (projPoint?.[1] / img_size_y <= location_pecto_bottom?.[1] + tolerance) pectoLevel = 'moderate';
      else pectoLevel = 'insufficient';
    }

    resultMLO.PectoNippleLength = pnl;
    resultMLO.PectLevel = pectoLevel;
  } catch (err) {
    console.log(err);
  }
}

export const addPNLEval = (resultCC, resultMLO, pnlDiffThresholds) => {
  try {
    if (pnlDiffThresholds === undefined || pnlDiffThresholds === null || !resultCC || !resultMLO) return;

    const pnlLengthCC = resultCC.PectoNippleLength;
    const pnlLengthMLO = resultMLO.PectoNippleLength;

    const pnlDiff = pnlLengthMLO - pnlLengthCC;
    if (isNaN(pnlDiff)) return;

    if (pnlDiff <= pnlDiffThresholds?.[0]) {
      resultCC.PNL = 'correct';
    } else if (pnlDiff <= pnlDiffThresholds?.[1]) {
      resultCC.PNL = 'moderate';
    } else if (pnlDiff > pnlDiffThresholds?.[1]) {
      resultCC.PNL = 'insufficient';
    }
  } catch (err) {
    console.log(err);
  }
};

export const addSymmetryEval = (resultLeft, resultRight, symmetryThresholds) => {
  try {
    if (symmetryThresholds === undefined || symmetryThresholds === null || !resultLeft || !resultRight)
      return;

    let center_left;
    if ('center_line' in resultLeft) center_left = resultLeft.center_line;
    else center_left = resultLeft.location_nipple?.[1];

    let center_right;
    if ('center_line' in resultRight) center_right = resultRight.center_line;
    else center_right = resultRight.location_nipple?.[1];

    const diff = Math.abs(center_left - center_right);
    if (isNaN(diff)) return;

    if (diff <= symmetryThresholds?.[0]) {
      resultLeft.symmetry = 'correct';
      resultRight.symmetry = 'correct';
    } else if (diff <= symmetryThresholds?.[1]) {
      resultLeft.symmetry = 'moderate';
      resultRight.symmetry = 'moderate';
    } else if (diff > symmetryThresholds?.[1]) {
      resultLeft.symmetry = 'insufficient';
      resultRight.symmetry = 'insufficient';
    }
  } catch (err) {
    console.log(err);
  }
};
